/**
 * Merge server actionLog full sync / delta payloads into client-side action log buffer.
 */

function appendActionLogDelta(base, delta) {
  if (!Array.isArray(delta)) {
    throw new Error('appendActionLogDelta: delta must be an array');
  }
  if (delta.length === 0) {
    return Array.isArray(base) ? base : [];
  }
  if (!Array.isArray(base)) {
    return delta.slice();
  }

  const merged = base.slice();
  const seenSequences = new Set(
    merged
      .map((entry) => entry?.sequence)
      .filter((sequence) => typeof sequence === 'number')
  );

  for (const entry of delta) {
    if (!entry || typeof entry !== 'object') {
      throw new Error('appendActionLogDelta: action log entry must be an object');
    }
    if (typeof entry.sequence === 'number') {
      if (seenSequences.has(entry.sequence)) {
        continue;
      }
      seenSequences.add(entry.sequence);
    }
    merged.push(entry);
  }

  return merged;
}

export function mergeActionLogFromWsMessage(prevLog, msg) {
  if (!msg || typeof msg !== 'object') {
    throw new Error('mergeActionLogFromWsMessage: msg is required');
  }

  if (msg.actionLogSync === 'full') {
    if (!Array.isArray(msg.gameState?.actionLog)) {
      throw new Error('mergeActionLogFromWsMessage: full sync requires gameState.actionLog array');
    }
    return msg.gameState.actionLog;
  }

  if (msg.actionLogSync === 'delta') {
    if (!Array.isArray(msg.actionLogDelta)) {
      throw new Error('mergeActionLogFromWsMessage: delta sync requires actionLogDelta array');
    }
    return appendActionLogDelta(prevLog, msg.actionLogDelta);
  }

  if (Array.isArray(msg.gameState?.actionLog)) {
    return msg.gameState.actionLog;
  }

  if (!Array.isArray(prevLog)) {
    return [];
  }
  return prevLog;
}

export function resolveWsMessageActionLog(prevLog, msg) {
  const mergedLog = mergeActionLogFromWsMessage(prevLog, msg);
  const gameStateWithLog = msg.gameState
    ? { ...msg.gameState, actionLog: mergedLog }
    : null;
  return { mergedLog, gameStateWithLog };
}
